export default "__VITE_ASSET__B2R2SY5T__"